import { render } from "./OWarningBox.vue?vue&type=template&id=6fb68c86&scoped=true"
import script from "./OWarningBox.vue?vue&type=script&lang=js"
export * from "./OWarningBox.vue?vue&type=script&lang=js"

import "./OWarningBox.vue?vue&type=style&index=0&id=6fb68c86&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb68c86"]])

export default __exports__